export default __webpack_public_path__ + "static/media/xlsIcon.304bd3d6.svg";